import itLocale from 'element-ui/lib/locale/lang/it'
import home from './it/home'

const it = {
    language: 'Русский',
    message: {
        'home': home,
    },
    '手机号码最小长度为8位': 'La lunghezza minima del numero di cellulare è di 8 cifre',
    '邮箱账号名称最小长度为6位': "La lunghezza minima del nome dell'account e-mail è di 6 caratteri",
    '邮箱只能包含英文，数字等字符': "La casella di posta può contenere solo caratteri come inglese e numeri",
    '请选择正确的收货地址': "Seleziona l'indirizzo di spedizione corretto",
    ...itLocale
}
export default it
